var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnreadFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447715 0.447715 0 1 0H16.7391C17.2914 0 17.7391 0.447715 17.7391 1C17.7391 1.55228 17.2914 2 16.7391 2H1C0.447715 2 0 1.55228 0 1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60864 6C2.60864 5.44772 3.05636 5 3.60864 5H14.1304C14.6827 5 15.1304 5.44772 15.1304 6C15.1304 6.55228 14.6827 7 14.1304 7H3.60864C3.05636 7 2.60864 6.55228 2.60864 6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21741 11C5.21741 10.4477 5.66512 10 6.21741 10H11.5218C12.074 10 12.5218 10.4477 12.5218 11C12.5218 11.5523 12.074 12 11.5218 12H6.21741C5.66512 12 5.21741 11.5523 5.21741 11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadFilterIcon);
export default __webpack_public_path__ + "static/media/unread_filter_icon.c57eec8aaafad8add1850f0383068a93.svg";
export { ForwardRef as ReactComponent };